import { type LbSoundMessage } from '../../services/users';
import { useCallback, useEffect } from 'react';
import { NO_SOUND, AudioFile } from './types';
import audioNotificationPlayer from './audioNotificationPlayer';

import { useDevices } from '../useDevices';
import { type CallStartSoundOptions } from '../../components/settings/preferences';

export const useAudio = (
  audioFile: AudioFile | typeof NO_SOUND,
): { play: () => void } => {
  const { selectedSpeakerId } = useDevices();

  useEffect(() => {
    if (typeof selectedSpeakerId !== 'undefined') {
      void audioNotificationPlayer.setAudioSink(selectedSpeakerId);
    }
  }, [selectedSpeakerId]);

  const play = useCallback(() => {
    if (audioFile === NO_SOUND) {
      return;
    }
    void audioNotificationPlayer.play(audioFile);
  }, [audioFile]);

  return { play };
};

export const soundMessageToAudioFile: Record<LbSoundMessage, AudioFile> = {
  'done-deal': AudioFile.DoneDeal,
  hammered: AudioFile.Hammered,
  likeable: AudioFile.Likeable,
  waitingfor: AudioFile.Waitingfor,
  'wakeup-call': AudioFile.WakeupCall,
};

export const callStartSoundToAudioFile: Record<
  CallStartSoundOptions,
  AudioFile
> = {
  chime: AudioFile.CallStart_Chime,
  doorbell: AudioFile.CallStart_Doorbell,
  'ta-da': AudioFile.CallStart_Tada,
  waitingfor: AudioFile.Waitingfor,
};
